import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=1067219f&scoped=true&"
import script from "./Advertisement.vue?vue&type=script&lang=js&"
export * from "./Advertisement.vue?vue&type=script&lang=js&"
import style0 from "./Advertisement.vue?vue&type=style&index=0&id=1067219f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1067219f",
  null
  
)

export default component.exports